/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotificationSettingsContent_notificationSettings$ref: FragmentReference;
declare export opaque type NotificationSettingsContent_notificationSettings$fragmentType: NotificationSettingsContent_notificationSettings$ref;
export type NotificationSettingsContent_notificationSettings = {|
  +currentUser: ?{|
    +orgStaff: ?{|
      +notificationConfig: ?any,
      +receiveSummaryEmails: ?boolean,
      +notificationSummaryInterval: ?string,
    |}
  |},
  +$refType: NotificationSettingsContent_notificationSettings$ref,
|};
export type NotificationSettingsContent_notificationSettings$data = NotificationSettingsContent_notificationSettings;
export type NotificationSettingsContent_notificationSettings$key = {
  +$data?: NotificationSettingsContent_notificationSettings$data,
  +$fragmentRefs: NotificationSettingsContent_notificationSettings$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "NotificationSettingsContent_notificationSettings",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentUser",
      "storageKey": null,
      "args": null,
      "concreteType": "UserNode",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "orgStaff",
          "storageKey": null,
          "args": null,
          "concreteType": "StaffNode",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "notificationConfig",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "receiveSummaryEmails",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "notificationSummaryInterval",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b6d391baf63ea001cd2e61a5a42f9ec5';
module.exports = node;
